<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false"
  [frontDispFlag]="true">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">取引先一覧</th>
    <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">
        <div>
          <wj-tab-panel id="tbb_Supplier" #Supplier [tabindex]="-1">
            <wj-tab>
              <a (click)="getSupplierList('ｱ', 0)">あ行</a>
              <div></div>
            </wj-tab>
            <wj-tab>
              <a (click)="getSupplierList('ｶ', 1)">か行</a>
              <div></div>
            </wj-tab>
            <wj-tab>
              <a (click)="getSupplierList('ｻ', 2)">さ行</a>
              <div></div>
            </wj-tab>
            <wj-tab>
              <a (click)="getSupplierList('ﾀ', 3)">た行</a>
              <div></div>
            </wj-tab>
            <wj-tab>
              <a (click)="getSupplierList('ﾅ', 4)">な行</a>
              <div></div>
            </wj-tab>
            <wj-tab>
              <a (click)="getSupplierList('ﾊ', 5)">は行</a>
              <div></div>
            </wj-tab>
            <wj-tab>
              <a (click)="getSupplierList('ﾏ', 6)">ま行</a>
              <div></div>
            </wj-tab>
            <wj-tab>
              <a (click)="getSupplierList('ﾔ', 7)">や行</a>
              <div></div>
            </wj-tab>
            <wj-tab>
              <a (click)="getSupplierList('ﾗ', 8)">ら行</a>
              <div></div>
            </wj-tab>
            <wj-tab>
              <a (click)="getSupplierList('ﾜ', 9)">わ行</a>
              <div></div>
            </wj-tab>
            <wj-tab>
              <a (click)="getSupplierList('', 10)">その他</a>
              <div></div>
            </wj-tab>
          </wj-tab-panel>
          <wj-flex-grid [style.height.px]="612" [style.width.px]="this.kymw0400Model.isMultiCheckable ? 722 : 679"
            id="dg_Supplier" #dg_Supplier [itemsSource]="kymw0400Model.supplierList" [isReadOnly]="true"
            [allowSorting]="true" [allowResizing]="true" [headersVisibility]="'Column'" [allowDragging]="'None'"
            [selectionMode]="'Row'" forcedEnabledMode="true" (dblclick)="onRowDoubleClick($event)"
            [tabindex]="0">
            <wj-flex-grid-column [visible]="this.kymw0400Model.isMultiCheckable" [minWidth]="5" [header]="''"
              [width]="45" [align]="'center'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                <input type="checkbox" class="selected" id="selected_{{cell.row.index}}" [(ngModel)]="cell.item.check"
                  (mouseup)="$event.stopPropagation()" [tabindex]="-1" />
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [width]="120" [header]="'取引停止区分'"
              [binding]="'TradeStopDivName'"></wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [width]="120" [header]="'取引先コード'"
              [binding]="'SupplierCode'"></wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [width]="420" [header]="'取引先名'"
              [binding]="'SupplierNameKanji'"></wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [width]="120" [binding]="'TradeStopDiv'"
              [visible]="false"></wj-flex-grid-column>
          </wj-flex-grid>
          <div id="tabpanel-support"></div>
        </div>
      </div>
    </td>
  </tr>

  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="footer-buttons">
          <button id="btn_Select" class="btn-primary" (click)="eventSelect_CLICKHandler($event)"
            forcedEnabledMode="true" [tabindex]="0">選択</button>
        </div>
        <div class="window-title-close">
          <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
          <button [tabindex]="0" (click)="onClickWindowClose()" (keydown)="eventNextTabHandler($event)"></button>
        </div>
      </td>
    </tr>
  </tfoot>
</table>